import Http from './Http';

export const postLogin = (data) => {
    return Http.post('/login', data);
};

export const getCommonInfo = () => {
    return Http.get('/public/common-info');
};

export const postRefreshToken = () => {
    return Http.post('/auth/refresh');
};

export const getMAGAA000 = (menuID) => {
    return Http.get(`/MAGAA000/${menuID}`);
};

export const putMAGAA000 = (menuID) => {
    return Http.put(`/MAGAA000/${menuID}`);
};

// MAAAA000
export const getMAAAA000 = () => {
    return Http.get('/MAAAA000');
};

export const postMAAAA000 = (data) => {
    return Http.post('/MAAAA000', data);
};

export const putMAAAA000 = (data) => {
    return Http.put('/MAAAA000', data);
};

export const deleteMAAAA000 = (id) => {
    return Http.post(`/MAAAA000/delete/${id}`);
};

// MAAAA001
export const getMAAAA001 = () => {
    return Http.get('/MAAAA001');
};

export const getMAAAA001Detail = (goodCode) => {
    return Http.get(`/MAAAA001/${goodCode}`);
};

export const putMAAAA001 = (goodCode, data) => {
    return Http.put(`/MAAAA001/${goodCode}`, data);
};

export const postMAAAA001ScheduledPrice = (goodCode, data) => {
    return Http.post(`/MAAAA001/${goodCode}/scheduled-price`, data);
};

export const putMAAAA001ScheduledPrice = (goodCode, data) => {
    return Http.put(`/MAAAA001/${goodCode}/scheduled-price`, data);
};

export const cancelMAAAA001ScheduledPrice = (goodCode, priceSeq) => {
    return Http.post(`/MAAAA001/${goodCode}/scheduled-price-cancel/${priceSeq}`);
};

// MABAA010
export const postMABAA010 = (data) => {
    return Http.post('/MABAA010', data);
};

export const deleteMABAA010 = (memberID) => {
    return Http.post(`/MABAA010/delete/${memberID}`);
};

export const postMABAA010Excel = (data, type) => {
    return Http.post(`/MABAA010/excel/download/${type}`, data);
};

export const getMABAA010ExcelCheckStatus = (id) => {
    return Http.get(`/MABAA010/excel/status/${id}`);
};

export const getMABAA010ExcelDownload = (url) => {
    return Http.get(`${url}`, { responseType: 'blob' });
};

// MABAA020
export const postMABAA020 = (data) => {
    return Http.post(`/MABAA020`, data);
};

// MABAA030
export const getMABAA030 = (id, tbl, memberGbn) => {
    return Http.get(`/MABAA030/${tbl}/${memberGbn}/${id}`);
};

export const getMABAA030Block = (memberID) => {
    return Http.get(`/MABAA030/block/${memberID}`);
};

export const putMABAA030 = (data) => {
    return Http.put('/MABAA030', data);
};

export const postMABAA030Block = (memberID) => {
    return Http.post(`/MABAA030/block/${memberID}`);
};

export const postMABAA030Leave = (data) => {
    return Http.post('/MABAA030/leave/add', data);
};

export const deleteMABAA030Block = (memberID) => {
    return Http.post(`/MABAA030/delete/${memberID}`);
};

export const putMABAA030ResetPassword = (seq, tbl) => {
    return Http.put(`/MABAA030/reset-pw?seq=${seq}&tbl=${tbl}`);
};
export const putMABAA030ResetAuth = (seq, tbl) => {
    return Http.put(`/MABAA030/reset-auth?seq=${seq}&tbl=${tbl}`);
};
export const getMABAA070Block = (memberID) => {
    return Http.get(`/MABAA070/block/${memberID}`);
};

export const postMABAA070Leave = (data) => {
    return Http.post('/MABAA070/leave/add', data);
};

export const postMABAA070Block = (memberID) => {
    return Http.post(`/MABAA070/block/${memberID}`);
};

export const deleteMABAA070Block = (memberID) => {
    return Http.post(`/MABAA070/delete/${memberID}`);
};

export const putMABAA030VitaminLetter = (vitaminLetter, id) => {
    return Http.put(`/MABAA030/dv/${vitaminLetter}/${id}`);
};

export const putMABAA030Bcs = (bcs, id) => {
    return Http.put(`/MABAA030/bc/${bcs}/${id}`);
};

export const putMABAA030Sms = (sms, id) => {
    return Http.put(`/MABAA030/sms/${sms}/${id}`);
};

export const postMABAA030Comments = (memberID, data) => {
    return Http.post(`/MABAA030/comments/${memberID}`, data);
};
export const getMABAA030Comments = (memberID) => {
    return Http.get(`/MABAA030/comments/${memberID}`);
};
// MABAA040
export const postMABAA040 = (id, config) => {
    return Http.post(`/MABAA040/${id}`, config);
};

// MABAA050
export const getMABAA050 = (id) => {
    return Http.get(`/MABAA050/${id}`);
};

// MABAA060
export const postMABAA060 = (id, config) => {
    return Http.post(`/MABAA060/${id}`, config);
};

export const postMABAA061 = (id, config) => {
    return Http.post(`/MABAA061/${id}`, config);
};

// MABAA070
export const getMABAA070 = (id) => {
    return Http.get(`/MABAA070/${id}`);
};

export const putMABAA070VitaminLetter = (vitaminLetter, id) => {
    return Http.put(`/MABAA070/dv/${vitaminLetter}/${id}`);
};

export const putMABAA070Bcs = (bcs, id) => {
    return Http.put(`/MABAA070/bc/${bcs}/${id}`);
};

export const putMABAA070Sms = (sms, id) => {
    return Http.put(`/MABAA070/sms/${sms}/${id}`);
};

// MABAA080
export const getMABAA080 = (id) => {
    return Http.get(`/MABAA080/${id}`);
};

export const postMABAA080Recruit = (memberID) => {
    return Http.post(`/MABAA080/recruit/${memberID}`);
};

// MABAA090
export const postMABAA090 = (id, config) => {
    return Http.post(`/MABAA090/${id}`, config);
};

// MABAA100
export const postMABAA100active = (id, config) => {
    return Http.post(`/MABAA101/${id}`, config);
};

export const postMABAA100unactive = (id, config) => {
    return Http.post(`/MABAA102/${id}`, config);
};

export const deleteMABAA102 = (id) => {
    return Http.post(`/MABAA102/delete/${id}`);
};

// MABAA110
export const postMABAA110Payment = (id, config) => {
    return Http.post(`/MABAA110/payment/${id}`, config);
};

export const postMABAA110Invoice = (id, config) => {
    return Http.post(`/MABAA110/invoice/${id}`, config);
};

// MABAA120
export const postMABAA120 = (id, config) => {
    return Http.post(`/MABAA120/${id}`, config);
};

// MAGAA010
export const postMAGAA010 = (config) => {
    return Http.post('/MAGAA010', config);
};

export const deleteMAGAA010 = (seq) => {
    return Http.post(`/MAGAA010/delete/${seq}`);
};

export const getMAGAA020Code = (code) => {
    return Http.get(`/MAGAA020/code/${code}`);
};

export const getMAGAA020Name = (name) => {
    return Http.get(`/MAGAA020/name/${name}`);
};

export const postMAGAA020 = (data) => {
    return Http.post(`/MAGAA020`, data);
};

export const putMAGAA020 = (data) => {
    return Http.put(`/MAGAA020`, data);
};

// MAGAB010
export const postMAGAB010 = (data) => {
    return Http.post('/MAGAB010', data);
};

// MAGAB020
export const getMAGAB020 = (id) => {
    return Http.get(`/MAGAB020/${id}`);
};

export const putMAGAB020 = (data) => {
    return Http.put('/MAGAB020', data);
};

export const postMAGAB020 = (data) => {
    return Http.post('/MAGAB020', data);
};
export const deleteMAGAB020 = (seq) => {
    return Http.post(`/MAGAB020/delete/${seq}`);
};

// MAGAC010
export const postMAGAC010 = (data) => {
    return Http.post('/MAGAC010', data);
};

// MAGAC020
export const getMAGAC020 = (id) => {
    return Http.get(`/MAGAC020/${id}`);
};

export const putMAGAC020 = (formData) => {
    return Http.put(`/MAGAC020`, formData, {
        headers: {
            Accept: 'application/json',
        },
    });
};

export const postMAGAC020 = (formData) => {
    return Http.post(`/MAGAC020`, formData);
};

export const deleteMAGAC020 = (seq) => {
    return Http.post(`/MAGAC020/delete/${seq}`);
};

export const getMAGAC020options = () => {
    return Http.get('/MAGAC020/options');
};

export const getMAGAC020Statistics = (id) => {
    return Http.get(`/MAGAC020/statistics/${id}`);
};

// MAGAC030
export const postMAGAC030 = (id, data) => {
    return Http.post(`/MAGAC030/${id}`, data);
};

export const postMAGAC030DeleteComment = (id) => {
    return Http.post(`/MAGAC030/delete-cmt/${id}`);
};

export const postMAGAC030Excel = (id, ext) => {
    return Http.post(`/MAGAC030/excel/download/${id}/${ext}`, {}, { responseType: 'blob' });
};

export const postMAGAC050Excel = (id, ext) => {
    return Http.post(`/MAGAC050/excel/download/${id}/${ext}`, {}, { responseType: 'blob' });
};

// MAEAA010
export const postMAEAA010 = (data) => {
    return Http.post('/MAEAA010', data);
};

// MAEAA020
export const getMAEAA020 = (id) => {
    return Http.get(`/MAEAA020/${id}`);
};

export const postMAEAA020 = (data) => {
    return Http.post(`/MAEAA020`, data);
};

export const putMAEAA020 = (data) => {
    return Http.put(`/MAEAA020`, data);
};

export const deleteMAEAA020 = (id) => {
    return Http.post(`/MAEAA020/delete/${id}`);
};

export const resetBannerADView = (id) => {
    return Http.put(`/MAEAA020/reset/${id}`);
};


// MAGAE010
export const postMAGAE010 = (config) => {
    return Http.post('/MAGAE010', config);
};

// MADAA010
export const postMADAA010 = (data) => {
    return Http.post('/MADAA010', data);
};

// MADAA020
export const getMADAA020 = (id) => {
    return Http.get(`/MADAA020/${id}`);
};
export const getPAJAC020TaskManager = () => {
    return Http.get(`/public/PAJAC020/task-manager`);
};
export const getPAJAC020CodeListPublic = (code) => {
    return Http.get(`/public/PAJAC020/code-list-public/${code}`);
};
export const deleteMADAA020 = (id) => {
    return Http.post(`/MADAA020/delete/${id}`);
};
export const postMADAA020 = (seq) => {
    return Http.post(`/MADAA020/change-lvl/${seq}`);
};

// MAGAF010
export const postMAGAF010 = (config) => {
    return Http.post('/MAGAF010', config);
};

// MAGAF020
export const getMAGAF020 = (id) => {
    return Http.get(`/MAGAF020/${id}`);
};

export const putMAGAF020 = (data) => {
    return Http.put('/MAGAF020', data);
};

export const postMAGAF020 = (data) => {
    return Http.post('/MAGAF020', data);
};
export const deleteMAGAF020 = (seq) => {
    return Http.post(`/MAGAF020/delete/${seq}`);
};

// MAGAG010
export const postMAGAG010 = (data) => {
    return Http.post('/MAGAG010', data);
};
export const deleteMAGAG010 = (seq) => {
    return Http.post(`/MAGAG010/delete/${seq}`);
};

// MAGAG020
export const getMAGAG020 = (id) => {
    return Http.get(`/MAGAG020/${id}`);
};

export const postMAGAG020 = (data) => {
    return Http.post('/MAGAG020', data);
};

export const putMAGAG020 = (data) => {
    return Http.put('/MAGAG020', data);
};

// MAGAI010
export const postMAGAI010 = (data) => {
    return Http.post('/MAGAI010', data);
};

// MAGAI020
export const getMAGAI020 = (id) => {
    return Http.get(`/MAGAI020/${id}`);
};

export const putMAGAI020 = (data) => {
    return Http.put('/MAGAI020', data);
};

export const deleteMAGAI020 = (id) => {
    return Http.post(`/MAGAI020/delete/${id}`);
};

// MAGAH010
export const postMAGAH010 = (config) => {
    return Http.post('/MAGAH010', config);
};

// MAGAH020
export const getMAGAH020 = (id) => {
    return Http.get(`/MAGAH020/${id}`);
};

export const putMAGAH020 = (data) => {
    return Http.put('/MAGAH020', data);
};

export const postMAGAH020 = (data) => {
    return Http.post('/MAGAH020', data);
};

export const deleteMAGAH020 = (id) => {
    return Http.post(`/MAGAH020/delete/${id}`);
};

// MAFAA030
export const postMAFAA030 = (data) => {
    return Http.post(`/MAFAA030`, data);
};

export const putMAFAA030 = (data) => {
    return Http.put('/MAFAA030', data);
};

export const deleteMAFAA030 = (id) => {
    return Http.post(`/MAFAA030/delete/${id}`);
};

export const putMAFAA030Limit = (data) => {
    return Http.put('/MAFAA030/limit', data);
};

export const putMAEAA010updatePosition = (data) => {
    return Http.put('/MAEAA010/update-position', data);
};

export const putMAFAA030updatePosition = (data) => {
    return Http.put('/MAFAA030/update-position', data);
};

export const postMAFAA030Comments = (data) => {
    return Http.post('/MAFAA030/comments', data);
};

export const postMAFAA030VisitedCount = (data) => {
    return Http.post('/MAFAA030/visitedCount', data);
};

// MAFAA040
export const postMAFAA040 = (data) => {
    return Http.post(`/MAFAA040`, data);
};

// MAFAA050
export const postMAFAA050 = (data) => {
    return Http.post(`/MAFAA050`, data);
};

// MAFAA060
export const postMAFAA060 = (data) => {
    return Http.post(`/MAFAA060`, data);
};
// MAFAA070
export const postMAFAA070 = (data) => {
    return Http.post(`/MAFAA070`, data);
};

// MAFAA080
export const postMAFAA080 = (data) => {
    return Http.post(`/MAFAA080`, data);
};

export const putMAFAA080 = (data) => {
    return Http.put('/MAFAA080', data);
};

// MABAA111
export const putMABAA111 = (data) => {
    return Http.put('/MABAA111', data);
};
export const getMABAA112 = (memberSeq) => {
    return Http.get(`/MABAA112/${memberSeq}`);
};
export const putMABAA112 = (data) => {
    return Http.put('/MABAA112', data);
};

// MAGAE020
export const getMAGAE020 = (id) => {
    return Http.get(`/MAGAE020/${id}`);
};

export const putMAGAE020 = (data) => {
    return Http.put('/MAGAE020', data);
};

export const postMAGAE020 = (data) => {
    return Http.post('/MAGAE020', data);
};

export const deleteMAGAE020 = (seq) => {
    return Http.post(`/MAGAE020/delete/${seq}`);
};
// MACAA010
export const postMACAA010 = (config) => {
    return Http.post('/MACAA010', config);
};

export const getMACAA010Action = (action, id) => {
    return Http.get(`/MACAA010/${action}/${id}`);
};

// MACAA020
export const postMACAA020 = (data) => {
    return Http.post('/MACAA020', data);
};

export const getMAGAD010 = (id) => {
    return Http.get(`/MAGAD010/${id}`);
};

export const getMAGAD010gubun = () => {
    return Http.get(`/MAGAD010/gubun`);
};

export const postMAGAD010 = (data) => {
    return Http.post('/MAGAD010', data);
};

export const postMAGAD010add = (formData) => {
    return Http.post('/MAGAD010/add', formData);
};

export const putMAGAD010 = (formData) => {
    return Http.put('/MAGAD010', formData);
};

export const deleteMAGAD010 = (id) => {
    return Http.post(`/MAGAD010/delete/${id}`);
};

// MAIAA010
export const postMAIAA010 = (data) => {
    return Http.post('/MAIAA010', data);
};
// MAIAA020
export const postMAIAA020 = (data) => {
    return Http.post('/MAIAA020', data);
};

export const putMAIAA020 = (data) => {
    return Http.put('/MAIAA020', data);
};
export const deleteMAIAA010 = (seq) => {
    return Http.post(`/MAIAA010/delete/${seq}`);
};

export const getMAIAA020DeMemberID = (id) => {
    return Http.get(`/MAIAA020/${id}`);
};

// MAIAB010
export const postMAIAB010 = (data) => {
    return Http.post('/MAIAB010', data);
};

export const postMAIAB010deleteCoupon = (data) => {
    return Http.post(`/MAIAB010/delete`, data);
};

export const postMAIAB010Download = (type, startDate, endDate) => {
    return Http.post(
        `/MAIAB010/excel/download/${type}`,
        {
            startDate,
            endDate,
        },
        { responseType: 'blob' },
    );
};

// MAIAC010
export const postMAIAC010 = (data) => {
    return Http.post('/MAIAC010', data);
};

// MAGAT010
export const postMAGAT010 = (data) => {
    return Http.post('/MAGAT010', data);
};

export const getMAGAT020 = (id) => {
    return Http.get(`/MAGAT020/${id}`);
};

export const postMAGAT020 = (data) => {
    return Http.post('/MAGAT020', data);
};

export const putMAGAT020 = (data) => {
    return Http.put('/MAGAT020', data);
};

export const deleteMAGAT020 = (id) => {
    return Http.post(`/MAGAT020/delete/${id}`);
};

export const getMABAA080Cancel = (config) => {
    return Http.get(`/MABAA080/recruit/cancel`, config);
};

export const getMABAA080AdminRegisterBanner = (config) => {
    return Http.get(`/MABAA080/info-admin-register-banner`, config);
};

export const postMABAA080AdminRegisterBanner = (data) => {
    return Http.post('/MABAA080/admin-register-banner', data);
};

export const putMABAA080AdminRecruitReuse = (data) => {
    return Http.put('/MABAA080/recruit/reuse', data);
};

export const putMABAA080RecruitClone = (data) => {
    return Http.put('/MABAA080/recruit/clone', data);
};

export const postMABAA080RecruitReRegExtra = (data) => {
    return Http.post(`/MABAA080/recruit/reRegExtra`, data);
};

export const postMABAA080RecruitFixJumpUp = (data) => {
    return Http.post(`/MABAA080/recruit/fix-jump-up`, data);
};

export const postMABAA080RecruitExpiredClone = (data) => {
    return Http.post(`/MABAA080/recruit-expired/clone`, data);
};

export const postMABAA080RecruitExpiredCloneDefault = (data) => {
    return Http.post(`/MABAA080/recruit-expired/clone-default`, data);
};

export const postMABAA080RecruitExtraGoodReuse = (data) => {
    return Http.post(`/MABAA080/extraGood/reuse`, data);
};

export const postMABAA080RecruitOtpGoodReuse = (data) => {
    return Http.post(`/MABAA080/otpGood/reuse`, data);
};

export const postMABAA030Comment = (data) => {
    return Http.post('/MABAA030/comment', data);
};

export const postMAIAA030 = (data) => {
    return Http.post('/MAIAA030', data);
};

export const getMAJAB010 = (date) => {
    return Http.get(`/MAJAB010?sDate=${date}`);
};

export const getMAJAC010 = (date) => {
    return Http.get(`/MAJAC010?sDate=${date}`);
};

export const getMAJAD010 = (date) => {
    return Http.get(`/MAJAD010?sDate=${date}`);
};

export const getMAJAD020 = (date) => {
    return Http.get(`/MAJAD020?sDate=${date}`);
};

export const postMAJAD020IpgumCheck = (data) => {
    return Http.post(`/MAJAD020/ipgum-check`, data);
};

export const getMAJAA010TicketsUsed = (data) => {
    return Http.get('/MAJAA010/tickets-used/export', { params: data, responseType: 'blob' });
};

export const getMAJAA010TicketsPurchase = (data) => {
    return Http.get('/MAJAA010/tickets-purchase/export', { params: data, responseType: 'blob' });
};

export const getMAJAA010TicketsRefund = (data) => {
    return Http.get('/MAJAA010/tickets-refund/export', { params: data, responseType: 'blob' });
};

export const getMAJAA010Payments = (data) => {
    return Http.get('/MAJAA010/payments/export', { params: data, responseType: 'blob' });
};
export const getMAJAA010CallProcedure = (data) => {
    return Http.get('/MAJAA010/call-procedure', { params: data, responseType: 'blob' });
};

// 누적매출및일평균매출
export const getTotalSalesAndAverageDailySales = (data) => {
    return Http.get('/MAJAC010/revenue/export', { params: data, responseType: 'blob' });
};

// 일별이력서등록현황
export const getDailyResumeRegistrationStatus = (data) => {
    return Http.get('/MAJAD030/daily/export', { params: data, responseType: 'blob' });
};

// 월별이력서등록현황
export const getMonthlyResumeRegistrationStatus = (data) => {
    return Http.get('/MAJAD030/yearly/export', { params: data, responseType: 'blob' });
};

// 회원집계
export const getMemberStatistics = (data) => {
    return Http.get('/MAJAC010/member/export', { params: data, responseType: 'blob' });
};

// 덴탈잡결제내역
export const getDentalJobPaymentHistory = (data) => {
    return Http.get('/MAJAB010/payment/export', { params: data, responseType: 'blob' });
};

// 덴탈잡이용권구매및사용현황
export const getDentalJobTicketPurchaseAndUsageStatus = (data) => {
    return Http.get('/MAJAB010/ticket/export', { params: data, responseType: 'blob' });
};


export const getDentalJobTicketUseStatusByMonth = (data) => {
    return Http.get('/MAJAC010/banner/export', { params: data, responseType: 'blob' });
};

// 월별광고상품이용현황
//...DOING getMonthlyAdvertisementProductUsageStatus

// 덴탈잡이용권사용현황
export const getDentalJobTicketUsageStatus = (data) => {
    return Http.get('/MAJAD010/ticket/export', { params: data, responseType: 'blob' });
};

export const getDentalJobTicketUsageStatusByDay = (data) => {
    return Http.get('/MAJAD010/ticket/export-by-day', { params: data, responseType: 'blob' });
};


export const dailyReport = ({ sDate }) => {
    return Http.get(`/MAJAA000?sDate=${sDate}`);
};


export const getMAJAD040 = () => {
    return Http.get('/MAJAD040');
};
export const getMAJAD030 = (date) => {
    return Http.get(`/MAJAD030?sDate=${date}`);
};

export const getMAJAD050 = (year, month, day) => {
    return Http.get(`/MAJAD050?year=${year}&month=${month}&day=${day}`);
};

export const getMAJAD050Ticket = (year, month, day) => {
    return Http.get(`/MAJAD050/ticket?year=${year}&month=${month}&day=${day}`);
};

export const getMAJAD050Resume = () => {
    return Http.get(`/MAJAD050/resume`);
};

export const getAdminLoginUser = (data) => {
    return Http.get('/admin-login-user', data);
};

// test MABAA031
export const getMABAA031 = (id, tbl, memberGbn) => {
    return Http.get(`/MABAA031/${tbl}/${memberGbn}/${id}`);
};

export const putMABAA031ResetPassword = (seq, tbl) => {
    return Http.put(`/MABAA031/reset-pw?seq=${seq}&tbl=${tbl}`);
};
export const postMABAA031 = (seq) => {
    return Http.post(`/MABAA031/integrated?seq=${seq}`);
};
export const putMABAA031ResetStatus = (seq) => {
    return Http.put(`/MABAA030/reset-status?seq=${seq}`);
};
export const putMABAA030ResetStatus = (seq) => {
    return Http.put(`/MABAA030/reset-status?seq=${seq}`);
};
